import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import AddressFormSp from '@/components/sp/AddressForm'
import LargeItemsFormSp from '@/components/sp/LargeItemsForm'
import MediumItemsFormSp from '@/components/sp/MediumItemsForm'
import SmallItemsFormSp from '@/components/sp/SmallItemsForm'
import SpecificDatetimeFormSp from '@/components/sp/SpecificDatetimeForm'
import CustomerFormSp from '@/components/sp/CustomerForm'
import ConfirmDispSp from '@/components/sp/ConfirmDisp'
import CompleteDispSp from '@/components/sp/CompleteDisp'
import AddressFormPc from '@/components/pc/AddressForm'
import LargeItemsFormPc from '@/components/pc/LargeItemsForm'
import MediumItemsFormPc from '@/components/pc/MediumItemsForm'
import SmallItemsFormPc from '@/components/pc/SmallItemsForm'
import SpecificDatetimeFormPc from '@/components/pc/SpecificDatetimeForm'
import CustomerFormPc from '@/components/pc/CustomerForm'
import ConfirmDispPc from '@/components/pc/ConfirmDisp'
import CompleteDispPc from '@/components/pc/CompleteDisp'
import DataEraseApplicationFormPc from '@/components/pc/DataEraseApplicationForm'
import DataEraseApplicationFormSp from '@/components/sp/DataEraseApplicationForm'
import DownloadCompleteDispPc from '@/components/pc/DownloadCompleteDisp'
import DownloadCompleteDispSp from '@/components/sp/DownloadCompleteDisp'
import ReportDownloadFormPc from '@/components/pc/ReportDownloadForm'
import ReportDownloadFormSp from '@/components/sp/ReportDownloadForm'


import common from '../js/common'

Vue.use(Router)

// エラー確認
function checkErrorFlg(to, from, next, path) {
  if (store.getters['errorFlg']) {
    next(path)
    common.setscrollTop()
  } else {
    next()
  }
}

// ストアから各種設定を取得
function getSettings(keys = []) {
  let settings = store.getters['settings']
  // 全ての設定を取得
  if (keys.length === 0) {
    return settings
  } else {
    // キーにより各種設定を取得
    return keys.reduce((acc, cur) => {
      if (settings[cur] !== undefined) {
        acc[cur] = settings[cur]
      }
      return acc
    }, {})
  }
}

function getCompItems() {
  let compItems = {}
  let isSmartPhone = common.isSmartPhone()
  compItems['largeItems'] = isSmartPhone ? LargeItemsFormSp.data()['items'] : LargeItemsFormPc.data()['items']
  compItems['mediumItems'] = isSmartPhone ? MediumItemsFormSp.data()['items'] : MediumItemsFormPc.data()['items']
  compItems['addMediumItem'] = isSmartPhone ? MediumItemsFormSp.data()['addItem'] : MediumItemsFormPc.data()['addItem']
  compItems['smallItems'] = isSmartPhone ? SmallItemsFormSp.data()['item'] : SmallItemsFormPc.data()['item']
  return compItems
}

const router = new Router({
  routes: [
    {
      path: common.constant.ADDRESS_FORM_PATH,
      component: common.isSmartPhone() ? AddressFormSp : AddressFormPc,
      props: () => ({
        ...getSettings(['siteCodeInfo', 'siteCodeItem']),
        'compItems': getCompItems()
      })
    },
    {
      path: common.constant.LARGE_ITEMS_PATH,
      component: common.isSmartPhone() ? LargeItemsFormSp : LargeItemsFormPc,
      props: () => (getSettings(['siteCodeInfo', 'siteCodeItem'])),
      beforeEnter(to, from, next) {
        checkErrorFlg(to, from, next, common.constant.ADDRESS_FORM_PATH)
      }
    },
    {
      path: common.constant.MEDIUM_ITEMS_PATH,
      component: common.isSmartPhone() ? MediumItemsFormSp : MediumItemsFormPc,
      props: () => (getSettings(['siteCodeInfo', 'siteCodeItem'])),
      beforeEnter(to, from, next) {
        checkErrorFlg(to, from, next, common.constant.LARGE_ITEMS_PATH)
      }
    },
    {
      path: common.constant.SMALL_ITEMS_PATH,
      component: common.isSmartPhone() ? SmallItemsFormSp : SmallItemsFormPc,
      props: () => (getSettings(['siteCodeInfo', 'siteCodeItem'])),
      beforeEnter(to, from, next) {
        checkErrorFlg(to, from, next, common.constant.MEDIUM_ITEMS_PATH)
      }
    },
    {
      path: common.constant.SPECIFIC_DATETIME_PATH,
      component: common.isSmartPhone() ? SpecificDatetimeFormSp : SpecificDatetimeFormPc,
      props: () => (getSettings(['siteCodeInfo'])),
      beforeEnter(to, from, next) {
        checkErrorFlg(to, from, next, common.constant.SMALL_ITEMS_PATH)
      }
    },
    {
      path: common.constant.CUSTOMER_INFORMATION_PATH,
      component: common.isSmartPhone() ? CustomerFormSp : CustomerFormPc,
      props: () => (getSettings(['siteCodeInfo', 'enqueteMaster'])),
      beforeEnter(to, from, next) {
        checkErrorFlg(to, from, next, common.constant.SPECIFIC_DATETIME_PATH)
      }
    },
    {
      path: common.constant.CONFIRMATION_SCREEN_PATH,
      component: common.isSmartPhone() ? ConfirmDispSp : ConfirmDispPc,
      props: () => (getSettings(['siteCodeInfo', 'enqueteMaster'])),
      beforeEnter(to, from, next) {
        checkErrorFlg(to, from, next, common.constant.CUSTOMER_INFORMATION_PATH)
      }
    },
    {
      path: common.constant.COMPLETE_PAGE_PATH,
      props: () => (getSettings(['siteCodeInfo'])),
      component: common.isSmartPhone() ? CompleteDispSp : CompleteDispPc,
    },
    {
      path: common.constant.DATA_ERASE_APPLICATION_FORM_PATH,
      props: () => (getSettings(['siteCodeInfo'])),
      component: common.isSmartPhone() ? DataEraseApplicationFormSp : DataEraseApplicationFormPc,
    },
    {
      path: common.constant.DOWNLOAD_COMPLETE_PAGE_PATH,
      props: () => (getSettings(['siteCodeInfo'])),
      component: common.isSmartPhone() ? DownloadCompleteDispSp : DownloadCompleteDispPc,
    },
    {
      path: common.constant.REPORT_DOWNLOAD_PAGE_PATH,
      props: () => (getSettings(['siteCodeInfo', 'siteCodeItem'])),
      component: common.isSmartPhone() ? ReportDownloadFormSp : ReportDownloadFormPc,
      
    }

  ],
  mode: 'history',
  base: process.env.BASE_URL
})

export default router
